var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPropertyTypeNumber(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-43 -653)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    rx: 1,
    transform: "translate(43 653)",
    fill: "#d9d9d9"
  }), /*#__PURE__*/React.createElement("text", {
    transform: "translate(49 662)",
    fill: "#fff",
    fontSize: 9,
    fontFamily: "HelveticaNeue-Medium,Helvetica Neue",
    fontWeight: 500
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -2.502,
    y: 0
  }, "1")))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPropertyTypeNumber);
export default __webpack_public_path__ + "static/media/propertyType-number.da4e1db2.svg";
export { ForwardRef as ReactComponent };